import { Component, Input, OnChanges, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiService } from "src/app/api.service";
import { TruncatedFilePipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-files-error",
	templateUrl: "./files-error.component.html",
	styleUrls: ["./files-error.component.scss"]
})
export class FilesErrorComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	@ViewChild("exceptionModal", { static: true }) public exceptionModal: any;

	public datafiles: APIResults.DataFile[];
	public selectedException: any = null;
	public selectedExceptionStack?: string = undefined;
	public selectedExceptionSubStack?: string = undefined;

	constructor(private modalService: NgbModal, private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		await this.RefreshData();
	}

	private async RefreshData() {
		this.datafiles = undefined;
		const datafiles = await this.api.GetErrorFiles(this.asset.asset_id, 0, 200);
		this.datafiles = datafiles;
	}

	public async DownloadFile(datafile: APIResults.DataFile) {
		const filename = new TruncatedFilePipe().transform(datafile.filename);
		await this.api.DownloadDataFile(this.asset.asset_id, datafile.datafile_id, filename);
	}

	public ShowException(exception: any) {
		try {
			this.selectedExceptionStack = undefined;
			this.selectedException = JSON.parse(exception);
			if (this.selectedException.stack) {
				this.selectedExceptionStack = this.selectedException.stack;
				delete this.selectedException.stack;
			}
			if (this.selectedException.detail && this.selectedException.detail.StackTrace) {
				this.selectedExceptionSubStack = this.selectedException.detail.StackTrace;
				delete this.selectedException.detail.StackTrace;
			}
		} catch (ex) {
			this.selectedException = exception;
		}
		this.modalService.open(this.exceptionModal, { size: "lg" });
	}
}
